import { Form, FormInstance } from 'antd';
import TcCard from 'components/UI/card/TcCard';
import TcForm from 'components/UI/form/TcForm';
import TcFormButtons from 'components/UI/FormButtons/TcFormButtons';
import TcPagination from 'components/UI/Pagination/TcPagination';
import TcTable from 'components/UI/Table/TcTable';
import useQuery from 'global/helperFunctions/useQuery';
import { IBackendSearch } from 'global/Models/globalModels';
import { ApiService } from 'global/utils/ApiService';
import { FC, ReactNode, useEffect } from 'react';

interface ITcListPage {
  columns: any;
  getList: (_a: object, _b: any) => void;
  loading: boolean;
  list: IBackendSearch | null | undefined;
  filterItems?: ReactNode;
  defaultQuery?: object;
  additionalContent?: ReactNode;
  additionalMoreContent?: ReactNode;
  noPagination?: boolean;
  rowKey?: string;
  customForm?: FormInstance;
  handleAbort?: () => void;
  tableProps?: any;
  noPrint?: boolean;
}

const TcListPage: FC<ITcListPage> = ({
  columns,
  getList,
  loading,
  list,
  filterItems,
  defaultQuery = {},
  additionalContent,
  additionalMoreContent,
  customForm,
  rowKey,
  noPagination,
  tableProps,
  noPrint = false,
}) => {
  //states

  //hooks
  const [form] = Form.useForm();
  const { query, search, setQuery, resetQuary, pageNumber, recordsPerPage, handlePagination } = useQuery();
  const apiService = new ApiService();

  //effect
  useEffect(() => {
    handleSearchChange(query, apiService);
    return () => apiService.abort();
  }, [search]);

  //functions
  const handleSearchChange = (values: any, apiService: any) => {
    if (customForm) {
      customForm.resetFields();
      customForm.setFieldsValue({ ...values });
    } else {
      form.resetFields();
      form.setFieldsValue({ ...values });
    }
    getList(values, apiService);
  };

  const handleSubmit = (values: object): void => setQuery({ ...defaultQuery, ...values, recordsPerPage });

  return (
    <div className='space-y-2'>
      {filterItems && (
        <TcCard title='فیلتر ها' size='small'>
          <TcForm size='middle' form={customForm || form} onFinish={handleSubmit}>
            <div className='grid grid-cols-1 gap-x-4 gap-y-2 sm:grid-cols-2 '>{filterItems}</div>
            <TcFormButtons onCancel={() => resetQuary(defaultQuery)} loading={loading} />
          </TcForm>
        </TcCard>
      )}
      <TcCard title='لیست' size='small'>
        <>{additionalContent}</>
        <TcTable
          count={list?.totalItemCount}
          refetch={() => getList(query, apiService)}
          dataSource={list?.data || []}
          columns={columns}
          loading={loading}
          current={pageNumber}
          rowKey={rowKey}
          pageSize={recordsPerPage}
          noPrint={noPrint}
          {...tableProps}
        />
        {!noPagination && (
          <TcPagination current={+pageNumber} pageSize={recordsPerPage} total={list?.totalItemCount} onPaginationHandler={handlePagination} showLessItems={false} />
        )}
        <>{additionalMoreContent}</>
      </TcCard>
    </div>
  );
};

export default TcListPage;
